export const FetchMethodType ={
    post:"POST",
    put:"PUT",
    patch:"PATCH",
    delete:"DELETE",
    get:"GET",
}